import { TechnologyWarning } from '@gd/game-technologies-check'
export default TechnologyWarning
